import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { getLocationQuery } from '@util'
import 'antd4/lib/grid/style/index.css'
import { Tag } from 'hljd'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import Item from './Item'
import styles from './style.module.less'

const FormItem = Form.Item
const CheckableTag = Tag.CheckableTag

@inject('centerStore', 'stepThreeStore')
@Form.create()
@observer
export default class extends Component {
  componentDidMount = () => {
    const { stepThreeStore } = this.props
    stepThreeStore.getForm(this.props.form)
    stepThreeStore.getMerchantAbbreviation()
  }

  getText = val => {
    if (!val) {
      return
    }
    const start = val[0]
    const end = val[1]
    if (start == 1 && end == 1) {
      return '请选择一项内容'
    } else if (start == 0) {
      return `请选择${start}-${end}项内容`
    } else {
      return `请选择至少${start}-${end}项内容`
    }
  }

  filterList = list => {
    let result = list
    const { merchant_info, isSingle } = this.props.centerStore

    let property_id = getLocationQuery('propertyId')
      ? getLocationQuery('propertyId')
      : merchant_info.property_id
    if (property_id == 12 && isSingle != 1) {
      result = []
      result = list.filter(item => item.id != 3902)
    }
    return result
  }

  getMarketInfo = value => {
    this.props.stepThreeStore.getMarketingInfoRecommend(value)
  }

  render() {
    const { tag_list } = this.props.stepThreeStore

    return (
      <div>
        <div className={styles.tip}>
          <ExclamationCircleFilled className={styles.left} />
          <span>
            {`标签会影响在首页、频道、搜索等页面的推荐，更精准的设置标签，快速获得更高的曝光和转化。`}
          </span>
        </div>
        <div className={styles.tags}>
          {this.filterList(tag_list)?.map((item, i) => {
            return (
              <div key={i} className={styles.item}>
                <Item label={item.name} required={!!item.required}>
                  <FormItem extra={<p>{this.getText(item.quantity_range)}</p>}>
                    {item.children?.map((child, j) => {
                      return (
                        <CheckableTag
                          key={j}
                          checked={child.isActive}
                          className="border"
                          onChange={flag =>
                            this.props.stepThreeStore.changeTagValue(i, j, flag)
                          }
                        >
                          {child.name}
                        </CheckableTag>
                      )
                    })}
                    <div className={styles.inner}>
                      <FormItem>
                        {this.props.form.getFieldDecorator(`tags${i}`)(
                          <span />
                        )}
                      </FormItem>
                    </div>
                  </FormItem>
                </Item>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}
